import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useLanguage } from '../../utils/language';

const Wrapper = styled.div`
  font-family: val(--font-family-opensans);
  font-weight: normal;
  font-size: 12px;
  color: val(--dark-gray);
  height: 18px;
`;

const CharacterCounter = ({ characterLimit, text }) => {
  const { dir } = useLanguage();
  const { t } = useTranslation();
  const charactersLeft = characterLimit - text.length;
  let info = '';
  if (charactersLeft === 1) {
    info = t('1 character left');
  } else if (charactersLeft > 1) {
    info = t('{{CHARACTER_COUNT}} characters left', {
      CHARACTER_COUNT: charactersLeft,
    });
  }

  return (
    <Wrapper dir={dir} data-testid="character-counter">
      {info}
    </Wrapper>
  );
};

CharacterCounter.propTypes = {
  characterLimit: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
};

export default CharacterCounter;
